/* eslint-disable camelcase */
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { PropTypes } from 'prop-types';
import { Button, Input, Form } from 'antd';
import ReCAPTCHA from 'react-google-recaptcha';

import IntlMessages from 'util/IntlMessages';
import InfoView from 'components/common/InfoView';
import { userSignIn } from '../redux/actions/Auth';
import logo from '../assets/images/kitegateway_icon_light.png';
import background from '../assets/images/bg/8.jpg';

const CAPTCHA_SITE_KEY = process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY;

const SignIn = (props) => {
  const dispatch = useDispatch();
  const token = useSelector(({ auth }) => auth.token);
  const [captchaToken, setCaptchaToken] = useState('');
  const captchaRef = useRef(null);
  const captchaReady = !CAPTCHA_SITE_KEY || !!captchaToken;
  const authUser = useSelector(({ auth }) => auth.authUser);
  const [mfaRequired, setMfaRequired] = useState(false);
  const [readOnly, setReadOnly] = useState(true);

  const { history } = props;

  const onFinishFailed = (errorInfo) => {
    console.error('Failed:', errorInfo);
  };

  const onFinish = (values) => {
    dispatch(userSignIn({ ...values, captcha_token: captchaToken })).then((result) => {
      setMfaRequired(!!result?.mfaRequired);
    });
    // A captcha token can only be verified once, so a fresh one is needed for every attempt
    if (captchaRef.current) captchaRef.current.reset();
    setCaptchaToken('');
  };

  useEffect(() => {
    if (token !== null && authUser) {
      history.push('/dashboard');
    } else {
      history.push('/signin');
    }
  }, [authUser, history, token]);

  const enablePasswordField = () => {
    setTimeout(() => setReadOnly(false), 300);
  };

  const disableAutoFill = () => {
    setReadOnly(true);
    enablePasswordField();
  };

  const passwordChanged = (e) => {
    if (e.target.value.trim().length === 0) {
      disableAutoFill();
    }
  };

  return (
    <div className="gx-app-login-wrap" style={{ backgroundImage: `url(${background})` }} >
      <div className="gx-app-login-container">
        <div className="gx-app-login-main-content">
          <div className="gx-app-logo-content">
            <div className="gx-app-logo-content-bg" />
            <div className="gx-app-logo-wid">
              <h1>
                <IntlMessages id="app.userAuth.signIn" />
              </h1>
              <h1>
                <IntlMessages id="app.userAuth.bySigning" />
              </h1>
              <p>
                <IntlMessages id="app.userAuth.getAccount" />
              </p>
            </div>
            <div className="gx-app-logo">
              <img
                src={logo}
                alt="Kitegateway"
                title="Kitegateway"
              />
            </div>
          </div>
          <div className="gx-app-login-content">
            <Form
              name="basic"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              className="gx-signin-form gx-form-row0"
              autoComplete="off"
            >
              <Form.Item
                rules={[
                  {
                    required: true,
                    type: 'email',
                    message: 'The input is not valid E-mail!',
                  },
                ]}
                name="email"
              >
                <Input placeholder="Email" autoComplete="username" />
              </Form.Item>
              <Form.Item
                rules={[
                  { required: true, message: 'Please input your Password!' },
                ]}
                name="password"
              >
                <Input onChange={passwordChanged} onContextMenu={(e) => e.preventDefault()} onClick={disableAutoFill} readOnly={readOnly} onFocus={enablePasswordField} type="password" placeholder="Password" autoComplete="off" />
              </Form.Item>
              {mfaRequired && (
                <Form.Item
                  rules={[
                    { required: true, message: 'Please input your two-factor authentication code!' },
                  ]}
                  name="otp"
                >
                  <Input placeholder="Two-factor authentication code" autoComplete="one-time-code" maxLength={8} />
                </Form.Item>
              )}
              <Form.Item>
                <Link
                  className="gx-login-form-forgot"
                  to="/forgot-password"
                >
                  Forgot password
                </Link>
              </Form.Item>
              {CAPTCHA_SITE_KEY && (
                <ReCAPTCHA
                  ref={captchaRef}
                  sitekey={CAPTCHA_SITE_KEY}
                  onChange={setCaptchaToken}
                  onExpired={() => setCaptchaToken('')}
                />
              )}
              <br />
              <Form.Item>
                <Button
                  type="primary"
                  className={`gx-mb-0 ${captchaReady ? 'enabled' : 'disabled'}`}
                  htmlType={captchaReady ? 'submit' : 'button'}
                >
                  <IntlMessages id="app.userAuth.signIn" />
                </Button>
                {/* <span>
                  <IntlMessages id="app.userAuth.or" />
                </span> */}
                {/* {' '}
                <Link to="/signup" className="gx-text-paylense-blue">
                  <IntlMessages id="app.userAuth.signUp" />
                </Link> */}
              </Form.Item>
            </Form>
          </div>
          <InfoView />
        </div>
      </div>
    </div>
  );
};

SignIn.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default SignIn;
